import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  preserveAspectRatio: "xMidYMid",
  viewBox: "0 0 11.907 11.907"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m7.369 5.953 4.245-4.245A1 1 0 0 0 10.2.293L5.954 4.538 1.708.293A1 1 0 0 0 .293 1.708l4.246 4.245L.293 10.2a1 1 0 0 0 1.415 1.415l4.246-4.247 4.246 4.245a1 1 0 0 0 1.414-1.413Z" }, null, -1)
  ])))
}
export default { render: render }